import React from 'react';

export default function SoldOutPage({ queryData, collectionId }) {
  const { textFor } = queryData;

  return (
    <main className="content-wrap scope-1892">
      <div id="primary-content" className="soldout-wrap">
        <div id="soldout-content" data-collection-id={collectionId}>
          <h1 data-property={textFor.soldoutPageHeading.key}>{textFor.soldoutPageHeading.value}</h1>
          <p className="h2" data-property={textFor.soldoutPageMessage.key}>{textFor.soldoutPageMessage.value}</p>
        </div>
      </div>
    </main>
  );
}
